import { useLocation, Link } from "react-router-dom";
import SEOMeta from "@/components/base/SEOMeta";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <SEOMeta
        title="Page Not Found | Serena's Quiet Recovery Space"
        description="The page you are looking for could not be found. Return to the homepage of Serena's Quiet Recovery Space for private alcohol recovery support."
        canonicalUrl={location.pathname}
        noIndex={true}
      />
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Page not found</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600 max-w-md mx-auto">
          The page you are looking for may have moved or no longer exists.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-block bg-primary-500 text-background-50 font-body text-sm font-medium px-6 py-3 rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Return home
          </Link>
          <Link
            to="/contact"
            className="inline-block font-body text-sm text-foreground-600 hover:text-foreground-900 px-6 py-3 rounded-md border border-background-300 hover:border-background-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Contact Serena
          </Link>
        </div>
      </div>
    </div>
  );
}